export default "/images/vendor/flag-icon-css/flags/4x3/vg.svg?7bc5c83294392b4386af3792418872b1";